import { render, staticRenderFns } from "./NoticeBoard.vue?vue&type=template&id=6bab3aa4"
import script from "./NoticeBoard.vue?vue&type=script&lang=js"
export * from "./NoticeBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports